import { pluralize } from "@sellar-io/common";
import { Icon } from "..";
import { BadgeGreen, BadgeZinc } from "../badge/Badge";
import { twMerge } from "tailwind-merge";

export const AssignedToCustomers = ({
  numberOfCustomers,
  numberOfZones,
  onClick,
  additionalText,
}: {
  numberOfCustomers: number;
  numberOfZones?: number;
  onClick: () => void;
  additionalText?: string;
}) => {
  return (
    <div
      onClick={() => numberOfCustomers > 0 && onClick()}
      className={twMerge(
        "flex items-center justify-between gap-2 rounded-lg border border-zinc-300 bg-zinc-50 p-2 text-xs",
        numberOfCustomers > 0 && "cursor-pointer",
      )}
    >
      <span className="flex items-center gap-2 text-sm font-semibold">
        {numberOfZones !== undefined &&
          numberOfZones >= 0 &&
          (numberOfZones === 0 ? (
            <BadgeZinc icon="MAP_MARKER">0</BadgeZinc>
          ) : (
            <BadgeGreen icon="MAP_MARKER">{numberOfZones}</BadgeGreen>
          ))}
        {numberOfCustomers === 0 ? (
          <BadgeZinc icon="ACCOUNT_MULTIPLE">0</BadgeZinc>
        ) : (
          <BadgeGreen icon="ACCOUNT_MULTIPLE">{numberOfCustomers}</BadgeGreen>
        )}
        Assigned to{" "}
        {numberOfZones !== undefined
          ? `${numberOfZones} delivery ${pluralize("zone", numberOfZones)} and`
          : ""}{" "}
        {numberOfCustomers} {pluralize("customer", numberOfCustomers)}{" "}
        {additionalText}
      </span>
      {numberOfCustomers > 0 && <Icon icon="CHEVRON_RIGHT" />}
    </div>
  );
};
